import m from "../../geodata/es2015/italyLow";
window.am4geodata_italyLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/italyLow.js
// module id = null
// module chunks = 